function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagCO(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURf7WJf/ZMP7TGtETKNcZLgE7mNwdMgRDpgNAoAZFqgZHrdghMPIAAAEYSURBVDjL1Yw9bsMwDEYZnUC5geETBJAOUECG5iwGNHYQPHdrs2UxqjGb4a1zT1mSsmTFSNTFHfr0w4/Us+FYR8K/EA4rMnNM+QAQi6TnVQUZP8AEgB0ZHICRy1onBMtorsPi8Y9pEq0QoimhgUChnIsS+lY0IFpU2eedQ2qhJQPhPkbKXMmAu8k2t0l4zh7Cd50vmOvc4DLP03RB4oByeqT8Bu9bprv8QCj5RCHU+AjXuhBYcGNwzoUxhqXi5nSFvh8dnrF3FHLFzemMQpU9hKHO6w6CtYP31lrv/WApeSL3L9AhNl9LyLmLQoUomNRi0FtBaa2MpgtvOoqPWoYnMHHII16sqo5EzPiHhIlFqwKjTqDq/C78AGfWTTc2Ct9HAAAAAElFTkSuQmCC",
    alt: "CO"
  }, props));
}